import { Button, ButtonGroup, Dialog, DialogBody, Tooltip } from '@blueprintjs/core';
import { useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';
import proyectosService from '../../services/proyectos.service';
import { AppContext } from '../../utils/context/app.context';
import { toast } from 'react-toastify';
import { AuthContext } from '../../utils/context/auth.context.ts';
import { Document, Page, pdfjs } from 'react-pdf';
import documentosService from '../../services/documentos.service.js';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    "pdfjs-dist/build/pdf.worker.min.mjs",
    import.meta.url,
).toString();


export default function ProyectoEntregablesCli(props) {
    const { proyecto, icon } = props;
    const [modal, setModal] = useState(false)
    const [item, setItem] = useState(null)
    const { t } = useTranslation();
    const appContext = useContext(AppContext);
    const authContext = useContext(AuthContext);

    const [numPages, setNumPages] = useState();
    const [pageNumber, setPageNumber] = useState(1);
    const [urlBlob, setUrl] = useState(null);
    const [selectedDoc, setDoc] = useState(null);

    async function get(i) {
        await proyectosService.get_cli(i.id)
            .then(res => {
                setItem(res.data);
                setModal(true);
            })
            .catch(error => appContext.errorHandler(error, toast, t))
            .finally(() => {

            })
    }

    const onDownloadBtn = (file, name) => {
        if (authContext.verify({ pathname: '/documentos' }, "GET")) {
            documentosService.load(file)
                .then(response => {
                    const contentDisposition = response.headers['content-disposition'];
                    const fileName = contentDisposition.split(';')[1].split('=')[1].replaceAll('"', '');
                    const type = fileName.split('.').pop();
                    // const mimeType = `application/${type}`;
                    const data = response.data;
                    const myBlob = new Blob([data]);

                    const blobUrl = window.URL.createObjectURL(myBlob);
                    const link = document.createElement("a");
                    link.href = blobUrl;
                    link.download = name + '.' + type;
                    document.body.appendChild(link);
                    link.click();
                    window.URL.revokeObjectURL(blobUrl);
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }

    const onLoadPdf = (file) => {
        if (authContext.verify({ pathname: '/documentos' }, "GET")) {
            documentosService.load(file)
                .then(response => {
                    const contentDisposition = response.headers['content-disposition'];
                    const fileName = contentDisposition.split(';')[1].split('=')[1].replaceAll('"', '');
                    const type = fileName.split('.').pop();
                    // const mimeType = `application/${type}`;
                    const data = response.data;
                    const myBlob = new Blob([data]);

                    const blobUrl = window.URL.createObjectURL(myBlob);
                    setUrl(blobUrl);
                })
                .catch(e => {
                    console.error(e);
                });
        }
    }

    const DOCS = (list) => {
        return <>
            {list.map(d => <>
                {d.url ? <div className='row'>
                    <div className='col'>
                        <h5><span className={`bp5-icon bp5-icon-document`} /> {d.descripcion}</h5>
                    </div>
                    <div className='col'>
                        <ButtonGroup>
                            <Tooltip content={t('actions.download')} placement="top">
                                <Button icon="cloud-download" intent='primary' onClick={() => {
                                    onDownloadBtn(d.url, d.descripcion)
                                }} />
                            </Tooltip>
                            {d.url.split('.').at(-1) === 'pdf'
                                ? <Tooltip content={t('actions.see_more')} placement="top">
                                    <Button icon="document" intent='primary' onClick={() => {
                                        setUrl(null)
                                        setDoc(d.descripcion)
                                        onLoadPdf(d.url)
                                    }} />
                                </Tooltip> : null}
                        </ButtonGroup>
                    </div>
                </div> : null}
            </>)}
        </>
    }

    function onDocumentLoadSuccess({ numPages }) {
        setNumPages(numPages);
    }

    const PDF_VIEWER = () => {
        return <div>
            {urlBlob ? <>
                <br />
                <hr />
                <h6>{selectedDoc} : {t('actions.page')} {t('actions.page')} {pageNumber} {t('actions.of')} {numPages}</h6>
                <ButtonGroup>

                    <Tooltip content={t('actions.prev')} placement="top">
                        <Button icon="chevron-left" intent='primary' disabled={pageNumber === 1} onClick={() => {
                            setPageNumber(pageNumber - 1)
                        }} />
                    </Tooltip>
                    <Tooltip content={t('actions.next')} placement="top">
                        <Button icon="chevron-right" intent='primary' disabled={pageNumber === numPages} onClick={() => {
                            setPageNumber(pageNumber + 1)
                        }} />
                    </Tooltip>
                </ButtonGroup>

                <Document file={urlBlob} onLoadSuccess={onDocumentLoadSuccess}>
                    <Page pageNumber={pageNumber} />
                </Document>
                <hr />
            </> : null}

        </div>
    }



    const MODAL = (i) => <Dialog
        title={t('entregables.title').replace('%VAR%', i?.codigo)}
        icon={icon || "projects"}
        isOpen={modal} onClose={() => setModal(false)}
        className='modal-app-cli'>
        <DialogBody useOverflowScrollContainer={true} >
            {DOCS(i.documentos)}
            {urlBlob ? PDF_VIEWER() : null}
        </DialogBody>
    </Dialog>

    return (<>
        {item ? MODAL(item) : null}
        <Tooltip content={t('pro.entregables')} placement="top">
            <Button icon={icon || "projects"} intent='warning' onClick={() => get(proyecto)} />
        </Tooltip>

    </>
    );
}
